import { IFilterElement, IGroup } from "../models/isearch-response";

const filterOpenCloseElements: NodeListOf<HTMLElement> = document.querySelectorAll(".accTrigger");
const filterContainer: HTMLElement = document.querySelector(".filter__container");
const boolFilterPrototype: HTMLElement = document.querySelector(".prototype__filter__bool");
const selectFilterPrototype: HTMLElement = document.querySelector(".prototype__filter__select");
const selectFilterItemPrototype: HTMLElement = document.querySelector(".prototype__filter_select__item");

/**
 * Öffnet bzw. schließt einen Filter
 */
function ToggleFilter(this: HTMLElement): void {
	this.parentElement.classList.toggle("open")
}

export const ToggleFilters = (): void => {
	filterOpenCloseElements.forEach(function (filterElement) {
		filterElement.addEventListener("click", ToggleFilter);
	});
};

export const UpdateFilters = (groups: IGroup[]): void => {
	filterContainer.innerHTML = "";
	groups.forEach(filter => {
		// Um rauszufinden, ob es sich um ein bool Element handelt, wird diese unschöne Logik benötigt.
		// Ein bool Element enthält immer 2 Elemente (true und false).
		const isBoolField = filter.elements.length === 2 && filter.elements.filter(x => x.name === "true") ||
			filter.selectedElements.length >= 1 && filter.selectedElements.filter(x => x.name === "true");
		if (isBoolField.length > 0) {
			HandleBoolFilterElement(isBoolField[0], filter);
		}
		else {
			HandleSelectFilterElement(filter);
		}
	});
};

function HandleSelectFilterElement(filter: IGroup): void {
	const selectFilter = selectFilterPrototype.cloneNode(true) as HTMLElement;
	selectFilter.querySelector(".filter__name").innerHTML = filter.name;

	if (filter.selectedElements.length + filter.elements.length > 6) {
		selectFilter.querySelector(".filter__menu").classList.add("scrollbar");
		selectFilter.querySelector(".filter__menu").classList.add("filter--date");
	}

	UpdateSelectFilter(filter.selectedElements, selectFilter);
	UpdateSelectFilter(filter.elements, selectFilter);
}

function UpdateSelectFilter(filterElements: IFilterElement[], selectFilter: HTMLElement): void {
	filterElements.forEach(filterElement => {
		const filterItem = selectFilterItemPrototype.cloneNode(true) as HTMLElement;
		filterItem.querySelector(".filter__label").innerHTML = `${filterElement.name} ${filterItem.querySelector(".filter__label").innerHTML}`;
		filterItem.setAttribute("data-url", filterElement.searchParams);
		if (filterElement.selected) {
			filterItem.querySelector(".filter__checkbox").classList.add("checked");
		}
		if (filterElement.recordCount > 0) {
			filterItem.querySelector(".filter__matches").innerHTML = `(${filterElement.recordCount})`;
		}

		selectFilter.querySelector(".filter__menu").append(filterItem);
	});

	filterContainer.append(selectFilter);
}

/**
 * Nicht die Standardmäßigen Filter sonder true/false Filter (z.B. FAO-Stunden)
 * Diese Filter müssen gesondert behandelt werden.
 */
function HandleBoolFilterElement(trueElement: IFilterElement, filter: IGroup): void {
	const boolFilter = boolFilterPrototype.cloneNode(true) as HTMLElement;
	boolFilter.classList.remove(".prototype__filter__bool");
	boolFilter.querySelector(".ffSearch").setAttribute("data-url", trueElement.searchParams);
	boolFilter.querySelector(".filter__label").innerHTML = filter.name;
	if (trueElement.selected) {
		boolFilter.querySelector(".filter__checkbox").classList.add("checked");
	}
	filterContainer.append(boolFilter);
}
